export default "__VITE_ASSET__sniJRfIY__"